"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var stripUnit_1 = require("../helper/stripUnit");
var is_1 = require("../helper/is");
var calculateBoxShadow = core_1.memo(function (values, ranges, easing) {
    var _a, _b;
    var min = ranges[0], max = ranges[1];
    var minMatch = (_a = is_1.boxShadowRegex.exec(min)) === null || _a === void 0 ? void 0 : _a.slice(1);
    var maxMatch = (_b = is_1.boxShadowRegex.exec(max)) === null || _b === void 0 ? void 0 : _b.slice(1);
    if (minMatch && minMatch.length === 8 && maxMatch && maxMatch.length === 8) {
        var _c = minMatch.map(function (item, index) {
            var _a = stripUnit_1.stripUnit(item), minValue = _a[0], minUnit = _a[1];
            var _b = stripUnit_1.stripUnit(maxMatch[index]), maxValue = _b[0], maxUnit = _b[1];
            var unit = minUnit || maxUnit || '';
            var value = core_1.interpolate(values, [minValue, maxValue], easing).toFixed(2);
            return "" + value + unit;
        }), horizontal = _c[0], vertical = _c[1], blur_1 = _c[2], spread = _c[3], red = _c[4], green = _c[5], blue = _c[6], alpha = _c[7];
        return horizontal + " " + vertical + " " + blur_1 + " " + spread + " rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
    }
    throw new Error("Modular System Error -> \"" + min + "\" or \"" + max + "\" is not a valid box shadow value.");
});
exports.boxShadow = function (value, range, easing) { return function (props) {
    var theme = props.theme;
    var values = core_1.getValue(value, theme);
    var ranges = core_1.getRange(range, theme);
    if (ranges.length === 1) {
        return ranges[0];
    }
    return calculateBoxShadow(values, ranges, easing);
}; };
exports.useBoxShadow = function (value, range, easing) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.boxShadow(value, range, easing)({ theme: theme });
};
//# sourceMappingURL=boxShadow.js.map